var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"slide-body bc-color"},[_c('b-row',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-img',{attrs:{"align":"bottom","src":require("@/images/slide22-tronic.png"),"fluid":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }